module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/node_modules/core-js/library/modules/_library.js
// module id = 161
// module chunks = 88 89